<template>
  <div class="basic bg-white p-4" v-if="Object.keys(customer).length > 0">
    <avatar class="m-auto" :size="200" :username="`${customer.first_name} ${customer.last_name}`"></avatar>
    <p class="text-center mt-4 mb-4 text-4xl text-gray-700">{{customer.first_name}} {{customer.last_name}}</p>
    <div class="divider"></div>
    <div class="px-12 pt-4">
      <div class="flex flex-wrap justify-between">
        <div class="information mb-4">
          <h5 class="text-xl font-bold">Customer Segment:</h5>
          <h6 class="text-md font-light">{{capitalize(customerRFM.customer_segment[0])}}</h6>
        </div>
        <div class="information mb-4">
          <h5 class="text-xl font-bold">Total Purchace Volume:</h5>
          <h6 class="text-md font-light">N/A</h6>
        </div>
        <div class="information mb-4">
          <h5 class="text-xl font-bold">Joined Since:</h5>
          <h6 class="text-md font-light">N/A</h6>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="px-12 pt-4">
      <div class="flex flex-wrap justify-between">
        <div class="information mb-4">
          <h5 class="text-xl font-bold">Age:</h5>
          <h6 class="text-md font-light">N/A</h6>
        </div>
        <div class="information mb-4">
          <h5 class="text-xl font-bold">Gender:</h5>
          <h6 class="text-md font-light">{{customer.gender}}</h6>
        </div>
        <div class="information mb-4">
          <h5 class="text-xl font-bold">Joined Since:</h5>
          <h6 class="text-md font-light">N/A</h6>
        </div>
        <div class="information mb-4">
          <h5 class="text-xl font-bold">Marital Status:</h5>
          <h6 class="text-md font-light">N/A</h6>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="px-12 pt-4">
      <div class="flex flex-wrap justify-between">
        <div class="information mb-4">
          <h5 class="text-xl font-bold">Phone:</h5>
          <h6 class="text-md font-light">N/A</h6>
        </div>
        <div class="information mb-4">
          <h5 class="text-xl font-bold">Email:</h5>
          <h6 class="text-md font-light">{{customer.email}}</h6>
        </div>
        <div class="information mb-4">
          <h5 class="text-xl font-bold">Address:</h5>
          <h6 class="text-md font-light">
            {{customer.address}}, {{customer.city}}, {{customer.state}}, {{customer.country}}
          </h6>
        </div>
        <div class="information mb-4">
          <h5 class="text-xl font-bold">Social Media:</h5>
          <h6 class="text-md font-light">N/A</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from 'vue-avatar';

export default {
  name: 'BasicInformation',
  components: {
    Avatar,
  },
  computed: {
    customer() {
      return this.$store.state.AICustomers.customer;
    },
    customerRFM() {
      return this.$store.state.AICustomers.customerRFM;
    },
  },
};
</script>

<style scoped lang="scss">
.basic {
  width: 50%;
  height: 800px;
  margin: 0 25%;
}

  .information {
    flex: 0 1 49%;

    & h6 {
      color: #c0c4cc !important;
    }
  }

  .divider {
    border-top: 1px lightgray solid;
  }
</style>
